module.exports = __webpack_public_path__ + "static/media/ARROW.7bdcd635.svg";